import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Odberatel.scss";

// proptypes
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";

// components
import Grid from "../../zisComponents/grid/Grid";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as odberatelActions from "../../actions/odberatel/odberatelActions";

class OdberatelGrid extends React.Component {
  constructor(props) {
    super(props);

    this.gridFilter = { filters: [] };
    this.gridSort = [];
    this.gridPage = { skip: 0, take: 10 };
  }


  // GRID PROPS
  genGridSchema = () => {
    const media = window.matchMedia('only screen and (min-width: 768px)');

    return media.matches ? [
      { field: "NAZOV", title: "Názov", width: "auto" },
      { field: "ICO", title: "IČO", width: "auto" },
      { field: "N_M", title: "Obec", width: "auto" },
      { field: "ULICA", title: "Ulica", width: "auto" },
      { field: "CO", title: "ČO", width: "auto" },
      { field: "CS", title: "ČS", width: "auto" },
    ] : [
      { field: "NAZOV", title: "Názov", width: "auto" },
      { field: "N_M", title: "Obec", width: "auto" },
    ];
  };
  genGridDetailSchema = () => {
    const media = window.matchMedia('only screen and (min-width: 768px)');

    return media.matches ? [
      { field: "I_ORGAN", title: "ID", width: "auto" },
      { field: "EMAIL1", title: "Email", width: "auto" },
      { field: "TELEFON", title: "Telefón", width: "auto" },
    ] : [
      { field: "I_ORGAN", title: "ID", width: "auto" },
      { field: "EMAIL1", title: "Email", width: "auto" },
      { field: "TELEFON", title: "Telefón", width: "auto" },
      { field: "ULICA", title: "Ulica", width: "auto" },
      { field: "ICO", title: "IČO", width: "auto" },
      { field: "CO", title: "ČO", width: "auto" },
      { field: "CS", title: "ČS", width: "auto" },
    ];
  };
  onChangeHandle = async (filter, sort, page) => {
    this.gridFilter = filter;
    this.gridSort = sort;
    this.gridPage = page;
  };
  onRowDoubleClickHandle = async (event) => {
    const data = this.buildChangeOdberatelData(event.dataItem);
    await this.props.changeOdberatel(data, true);
  };
  getListOdberatelHandle = async () => {
    const { customFilters, getListOdberatel } = this.props;
    const { gridFilter, gridSort, gridPage } = this;
    await getListOdberatel(gridFilter, gridSort, gridPage, customFilters);
  };

  // METHODS
  buildGridsProps = () => {
    const {
      gridFilter,
      gridPage,
      gridSort,
      gridFilterZmluvy,
      gridPageZmluvy,
      gridSortZmluvy,

      gridFilterOM,
      gridPageOM,
      gridSortOM,

      gridFilterFaktura,
      gridSortFaktura,
      gridPageFaktura,
    } = this.props;

    return {
      odberatel: {
        gridFilter: gridFilter,
        gridSort: gridSort,
        gridPage: gridPage,
      },
      zmluvy: {
        gridFilter: gridFilterZmluvy,
        gridSort: gridSortZmluvy,
        gridPage: gridPageZmluvy,
      },
      OM: {
        gridFilter: gridFilterOM,
        gridSort: gridSortOM,
        gridPage: gridPageOM,
      },
      faktury: {
        gridFilter: gridFilterFaktura,
        gridSort: gridSortFaktura,
        gridPage: gridPageFaktura,
      },
    };
  };
  buildChangeOdberatelData = (odberatel) => {
    const grids = this.buildGridsProps();

    return {
      odberatel,
      grids,
    };
  };

  // SYSTEM METHODS
  componentDidMount() {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(true);
    changeHeaderTitle("Odberatelia");
  }
  componentWillUnmount = () => {
    this.props.showAppHeader(false);
  }
  render() {
    const {
      isOdberatelPickedByDoubleClickInGridRow,
      listOdberatel,
      odberatel,
      isLoading,
      total,
    } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <Grid
            data={
              isOdberatelPickedByDoubleClickInGridRow
                ? [odberatel]
                : listOdberatel
            }
            detailSchema={this.genGridDetailSchema()}
            isLoading={isLoading}
            onChange={this.onChangeHandle}
            onGet={() => { }}
            onGetList={this.getListOdberatelHandle}
            onRowDoubleClick={this.onRowDoubleClickHandle}
            primaryField="I_ORGAN"
            schema={this.genGridSchema()}
            total={isOdberatelPickedByDoubleClickInGridRow ? 1 : total}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // list odberatel
    isLoading: state.listOdberatel.isLoading,
    listOdberatel: state.listOdberatel.data,
    total: state.listOdberatel.total,
    customFilters: state.listOdberatel.customFilters,
    gridFilter: state.listOdberatel.gridFilter,
    gridSort: state.listOdberatel.gridSort,
    gridPage: state.listOdberatel.gridPage,

    // odberatel
    isOdberatelPickedByDoubleClickInGridRow: state.odberatel.isPickedByDoubleClickInGridRow,
    odberatel: state.odberatel.data,

    // ZMLUVY GRID
    gridFilterZmluvy: state.listZmluva.gridFilter,
    gridSortZmluvy: state.listZmluva.gridSort,
    gridPageZmluvy: state.listZmluva.gridPage,

    // OM GRID
    gridFilterOM: state.listOM.gridFilter,
    gridSortOM: state.listOM.gridSort,
    gridPageOM: state.listOM.gridPage,

    // FAKTURY GRID
    gridFilterFaktura: state.listFaktura.gridFilter,
    gridSortFaktura: state.listFaktura.gridSort,
    gridPageFaktura: state.listFaktura.gridPage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getListOdberatel: async (gridFilter, gridSort, gridPage, customFilters) => await dispatch(odberatelActions.getListOdberatel({ gridFilter, gridSort, gridPage, customFilters })),
  changeHeaderTitle: (title) => dispatch(appHeaderActions.changeHeaderTitle(title)),
  changeOdberatel: async (data, gridRowDoubleClicked = false) => await dispatch(odberatelActions.changeOdberatel(data, gridRowDoubleClicked)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

OdberatelGrid.propTypes = {
  getlistOdberatel: PropTypes.func,
  changeHeaderTitle: PropTypes.func,
  changeOdberatel: PropTypes.func,
  isLoading: PropTypes.bool,
  isOdberatelPickedByDoubleClickInGridRow: PropTypes.bool,
  listOdberatel: PropTypes.arrayOf(odberatelPropTypes.odberatel),
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(OdberatelGrid);
